import React, { FunctionComponent } from 'react'
import { Popover as TinyPopover, PopoverProps } from 'react-tiny-popover'
import { isHtmlElement } from '../../utils/type-guards'
import { isPathIncludes } from '../../utils/utils'

const Popover: FunctionComponent<PopoverProps> = (props) => <TinyPopover
    padding={4}
    positions={['bottom', 'top']}
    {...props}
    onClickOutside={event => {
        if (
            !(isHtmlElement(event.target) && event.target.tagName === 'BODY') && // avoid Chrome onMouseUp
            !isPathIncludes(event, 'react-tiny-popover') // for inner popovers
        ) {
            props.onClickOutside?.(event)
        }
    }}
/>

export default Popover